var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloadHover = function SvgDownloadHover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E60021",
    d: "m32 21-1.41-1.41L25 25.17V13h-2v12.17l-5.58-5.59L16 21l8 8zM18 33h12v2H18z"
  })));
};
export { SvgDownloadHover as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMyIDIxTDMwLjU5IDE5LjU5TDI1IDI1LjE3VjEzSDIzVjI1LjE3TDE3LjQyIDE5LjU4TDE2IDIxTDI0IDI5TDMyIDIxWiIgZmlsbD0iI0U2MDAyMSIvPgo8cGF0aCBkPSJNMTggMzNIMzBWMzVIMThWMzNaIiBmaWxsPSIjRTYwMDIxIi8+Cjwvc3ZnPgo=";